import { FulfilmentCircle, Shipping } from '@components/icons'
import { FC } from 'react'

interface Props {
  inventory: number
  shippable: boolean
}

const Delivery: FC<Props> = ({ inventory, shippable }) => {
  return (
    <div className="flex flex-col justify-between border-b mb-3 pb-4 border-ui-grey-25">
      <div className="flex items-center">
        <svg
          width="18"
          height="14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <Shipping />
        </svg>
        <div className="flex w-full justify-between">
          <div className="flex items-center">
            <div className="text-label font-bold pl-0.6 text-text-subdued">
              Delivery
            </div>
            <div className="ml-2">
              {shippable && inventory > 0 ? (
                <FulfilmentCircle fill="#67CE67" />
              ) : (
                <FulfilmentCircle fill="#EB001B" />
              )}
            </div>
          </div>
          {/* <div className="text-label font-bold text-text-subdued">Free</div> */}
        </div>
      </div>
      {/* <div className="text-body2 pl-0.8 text-text-subdued underline pb-4">
        Check delivery availability
      </div> */}
    </div>
  )
}

export default Delivery
